/** addUrlParamsWithoutOverwriting will add query parameters to a url if the url does not already include the new
 * parameter
 *
 * An error will be thrown if the inputUrl is invalid. See
 * https://developer.mozilla.org/en-US/docs/Web/API/URL/URL#exceptions
 *
 * @param inputUrl string | URL - URL to add params to. Throws if this URL is invalid
 * @param inputParams string | string[][] | Record<string, string> | URLSearchParams | undefined - Parameters to add
 * @returns URL
 */
export const addUrlParamsWithoutOverwriting = (inputUrl, inputParams) => {
    const url = new URL(inputUrl);
    const params = new URLSearchParams(inputParams);
    const { searchParams } = url;
    const existingSearchEntries = [...searchParams.entries()];
    // Rebuild search params from scratch
    url.search = '';
    // Add on new params
    params.forEach((val, key) => {
        searchParams.append(key, val);
    });
    // Delete any conflicting existing values
    existingSearchEntries.forEach(([key]) => {
        searchParams.delete(key);
    });
    // Append back original params
    existingSearchEntries.forEach(([key, val]) => {
        searchParams.append(key, val);
    });
    return url;
};
//# sourceMappingURL=add-url-params-without-overwriting.js.map